module.exports = __webpack_public_path__ + "img/dot-orange.3488c7e7.svg";